module.exports = "/images/sc.svg?d2cbdb7c91b6a5cebc62b2dab2e006d9";